export default {
 taskRecord: {
   title: "タスク報酬",
   loading: "読み込み中...",
   empty: "報酬がありません",
   completed: "このタスクは完了しました",
   desc: "タスクを完了すると報酬を受け取れます",
   close: "閉じる",
   add: "追加",
   addEmail: "メールアドレスを追加",
   addPhoneNumber: "電話番号を追加",
   addBirthday: "誕生日を追加",
   downloadNow: "今すぐダウンロード",
   phone: "電話番号",
   email: "メールアドレス",
   bank: "銀行カード",
   birthday: "誕生日",
   download: "ダウンロード",
   downloadApp: "APPをダウンロード",
   registerBonus: "登録ボーナス",
   firstInviteBonus: "初回招待ボーナス",
   invite: "招待",
   inviteNow: "友達を招待",
   go: "進む",
   receive: "受け取る",
   received: "受け取り済み",
   task: "タスク",
   claimRewards: '報酬を受け取る',
   receiveSuccess: '報酬を受け取りました',
   receiveFail: '報酬の受け取りに失敗しました'
 }
};
